window.addEventListener('load', function () {
  var currentLocation = window.location,
    supportSidebar = getElements('faq-support__sidebar')[0],
    supportSidebarContent = getElements('faq-support__sidebar-content')[0],
    supportContent = getElements('faq-support__content-main')[0],
    feedbackContainerStepOne = getElements('faq-support__feedback-main--first-step')[0],
    feedbackContainerStepTwo = getElements('faq-support__feedback-main--second-step')[0],
    feedbackContainerStepFinal = getElements('faq-support__feedback-main--final-step')[0],
    feedbackContactUsLabel = getElements('faq-support__feedback-contact-us')[0],
    feedbackCtaStepOne = getElements('faq-support__feedback-thumbs'),
    feedbackCtaStepTwo = getElements('faq-support__feedback-cta'),
    feedbackInput = getElements('faq-support__feedback-input')[0],
    searchInput = getElements('faq-support__search-input')[0],
    searchForm = getElement('faq-support-search-form'),
    supportPageProductList = getElements('faq-support__list'),
    sideBarTopicList = getElements('faq-support__recent-topics-list-item a'),
    faqLoadMoreArticles = getElements('faq-support__article-more'),
    faqBreadcrumbLinks = getElements('faq-support__breadcrumb-link'),
    faqBreadcrumbLinks = getElements('faq-support__breadcrumb-link'),
    faqResourceCardItems = getElements('faq-support__resource-card'),
    faqItems = getElements('faq-support__aticles-item a'),
    recentTopicsHiddenList = getElements('faq-support__recent-topics-list-item--hidden'),
    searchPressLabel = getElements('faq-support__search-enter-icon')[0],
    searchClear = getElement('faq-support-search-clear'),
    searchEnterAndClear = getElements('faq-support__search-submit-clear')[0],
    contactUsContainer = getElements('faq-support__contactus-container')[0],
    recentTopicCta = getElement('recent-topics-cta'),
    catPageBottomContactUsLink = getElements('faq-support__contactus-link')[0],
    isSupportPage = document.body.classList.contains('support') > -1;
    isProductOrFolderPage = document.body.classList.contains('tax-questions-categories') > -1,
    faqSecondaryTopicsLinks = getElements('faq-support__article-content--main a'),
    searchFocusFlag = true;

  function getURLparam(param) {
    var url_string = window.location.href,
      url = new URL(url_string),
      ref = url.searchParams.get(param);
    return ref;
  }
  function removeMainContentHashFromUrl() {
    var urlHash = window.location.hash;
    if (urlHash) {
      var currentUrl = window.location.href.replace(urlHash, '');
      window.history.pushState({}, '', currentUrl);
    }
  }
  function toPascleCase(str) {
    if (!str) {
      return;
    }
    return str
      .replace(new RegExp(/[-_]+/, 'g'), ' ')
      .replace(new RegExp(/[^\w\s]/, 'g'), '')
      .replace(new RegExp(/\s+(.)(\w*)/, 'g'), function ($1, $2, $3) {
        return $2.toUpperCase() + $3.toLowerCase();
      })
      .replace(new RegExp(/\w/), function (s) {
        return s.toUpperCase();
      });
  }

  function replaceFreshdeskUrl(str) {
    return str.replace(
      new RegExp('https://s3.amazonaws.com/cdn.freshdesk.com', 'g'),
      'https://www.browserstack.com/freshdesk-assets'
    );
  }
  // EdsEvent Global function
  function getEDSEvents(data) {
    var currentUrl = window.location.href;
    var referrer = getURLparam('ref') || document.referrer;
    if (!data) data = {};
    var signedIn = false;
    // path name:  ['supportPage', relatedResources, breadcrumb, productPage, folderPage];
    return {
      onSupportLoad: {
        name: 'onSupportPage',
        options: { url: currentUrl, referrer: referrer, signed_in: signedIn },
      },
      onFAQLoad : {
        name: 'ReadFAQ',
        options: { url: currentUrl, referrer: referrer, signed_in: signedIn },
      },
      FaqSupportSearchFocus: {
        name: 'FaqSupportSearchFocus',
        options: { url: currentUrl, signed_in: signedIn },
      },
      FaqSupportSearchSubmit: {
        name: 'FaqSupportSearchSubmit',
        options: { url: currentUrl, search_text: data.searchText, signed_in: signedIn },
      },
      FaqSupportProductClicked: {
        name: 'FaqSupportProductClicked',
        options: {
          url: currentUrl,
          path_name: data.pathName,
          product: data.productName,
          signed_in: signedIn,
          link_clicked: data.linkClicked,
        },
      },
      FaqSupportFolderClicked: {
        name: 'FaqSupportFolderClicked',
        options: {
          url: currentUrl,
          path_name: data.pathName,
          signed_in: signedIn,
          product: data.productName,
          folder: data.folderName,
          link_clicked: data.linkClicked,
        },
      },
      FaqSupportBreadCrumbClicked: {
        name: 'FaqSupportBreadCrumbClicked',
        options: {
          url: currentUrl,
          signed_in: signedIn,
          type: data.type,
          title: data.title,
          link_clicked: data.linkClicked,
        },
      },
      FaqSupportFaqClicked: {
        name: 'FaqSupportFaqClicked',
        options: {
          url: currentUrl,
          path_name: data.pathName,
          signed_in: signedIn,
          product: data.productName,
          folder: data.folderName,
          faq_title: data.title,
          link_clicked: data.linkClicked,
        },
      },
      FaqSupportDocumentationClicked: {
        name: 'FaqSupportDocsSupportClicked',
        options: {
          url: currentUrl,
          product: data.productName,
          folder: data.folderName,
          faq: data.faqName,
          signed_in: signedIn,
          link_clicked: data.linkClicked,
        },
      },
      FaqSupportStatusClicked: {
        name: 'FaqStatusPageSupportClicked',
        options: {
          url: currentUrl,
          path_name: data.pathName,
          product: data.productName,
          folder: data.folderName,
          faq: data.faqName,
          signed_in: signedIn,
          link_clicked: data.linkClicked,
        },
      },
      FaqSupportContactClicked: {
        name: 'FaqContactPageSupportClicked',
        options: {
          url: currentUrl,
          path_name: data.pathName,
          product: data.productName,
          folder: data.folderName,
          faq: data.faqName,
          signed_in: signedIn,
          link_clicked: data.linkClicked,
        },
      },
      FAQFeedbackGiven: {
        name: 'FAQFeedbackGiven',
        options: {
          signed_in: signedIn,
          user_signed_in: signedIn,
          title: data.title,
          is_useful: data.isUseful,
          review_text: data.reviewText,
          url: currentUrl,
          time: data.time,
          team: 'web',
        },
      },
      FaqBottomContactUsClicked: {
        name: 'FaqBottomContactUsClicked',
        options: {
          url: currentUrl,
          product: data.productName,
          folder: data.folderName,
          signed_in: signedIn,
          link_clicked: data.linkClicked,
        },
      },
      FAQSuggestedLinkClicks: {
        name: 'FAQSuggestedLinkClicks',
        options: {
          path_name: data.pathName,
          link_clicked: data.linkClicked,
          url: currentUrl,
        },
      },
      FaqSupportProductVisited: {
        name: 'FaqSupportProductVisited',
        options: {
          path_name: data.pathName,
          product: data.productName,
          link_clicked: data.linkClicked,
        },
      },
      FaqSupportDynamicSearchClicked: {
        name: 'FaqSupportDynamicSearchClicked',
        options: {
          action: data.action,
          clicked_on_URL: data.clicked_on_url,
          position: data.position,
          search_text: data.search_text,
          content_Type: data.content_type
        },
      },
    };
  }
  // Log EDS events
  function logEdsEvent(eventName, eventData) {
    if (window.WebEventTracker && window.WebEventTracker.logEvent && window.EDS) {
      setTimeout(function () {
        window.WebEventTracker.logEvent(window.EDS.webEvents, eventName, eventData);
      }, 10);
    }
  }
  // get Current Scroll
  function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }
  function getElement(id) {
    return document.getElementById(id);
  }
  function getElements(className) {
    return document.querySelectorAll('.' + className);
  }
  function from(array, callback) {
    for (var index = 0; index < array.length; index++) {
      callback(array[index], index);
    }
  }
  function formatSizeUnits(bytes) {
    if (bytes >= 1073741824) {
      bytes = Number(bytes / 1073741824).toFixed(2) + ' GB';
    } else if (bytes >= 1048576) {
      bytes = Number(bytes / 1048576).toFixed(2) + ' MB';
    } else if (bytes >= 1024) {
      bytes = Number(bytes / 1024).toFixed(0) + ' KB';
    } else if (bytes > 1) {
      bytes = bytes.toFixed(0) + ' bytes';
    } else if (bytes == 1) {
      bytes = bytes + ' byte';
    } else {
      bytes = '0 bytes';
    }
    return bytes;
  }
  function handleRenderAttachments(attachments) {
    if (attachments && attachments.length) {
      from(attachments, function (item, index) {
        var attachmentItem = getElement('faq-support-attachment-' + index);
        if (!attachmentItem) return;
        attachmentItem.classList.remove('faq-support__attachment--no-pointer-events');
        attachmentItem.querySelector('.faq-support__attachment-name').innerHTML = item.name;
        attachmentItem.querySelector('.faq-support__attachment-size').innerHTML = formatSizeUnits(item.size);
        attachmentItem.querySelector('.faq-support__attachment-type').innerHTML = item.name.split('.')[1] + ' -';

        attachmentItem.href = replaceFreshdeskUrl(item.attachment_url);
      });
    }
  }
  function fetchAttachments(id) {
    var xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
      handleRenderAttachments(JSON.parse(this.response));
    };
    xhttp.open('GET', '/wp-json/get-attachment-details/v1/faq/' + id);
    xhttp.send();
  }
  function searchScrollHandler() {
    var pageScroll = 100,
      supportSearchHeader = getElements('faq-support__search')[0],
      body = document.body,
      scroll = getCurrentScroll();
    if (scroll >= pageScroll) {
      body.classList.add('scroll-effect-on');
      supportSearchHeader.classList.add('scroll-effect');
    } else {
      body.classList.remove('scroll-effect-on');
      supportSearchHeader.classList.remove('scroll-effect');
    }
  }

  function sidebarScrollHandler() {
    var sideBarFixedClass = 'faq-support__sidebar--fixed',
      sideBarBottomFixedClass = 'faq-support__sidebar--bottom-fixed';
    if (document.body.clientWidth < 1024) {
      return;
    }
    if (!supportSidebarContent && !supportContent) {
      return;
    }
    var contentIsLess = supportSidebarContent.clientHeight > supportContent.clientHeight;
    var pageScroll = 180,
      scroll = getCurrentScroll();
    if (scroll >= pageScroll && !contentIsLess) {
      supportSidebar.classList.add(sideBarFixedClass);
      supportSidebar.classList.remove(sideBarBottomFixedClass);
    } else {
      supportSidebar.classList.remove(sideBarFixedClass);
    } // for footer
    var scrollTop = getCurrentScroll(),
      isCatPage = window.location.pathname.indexOf('/support/') > -1,
      footerTop = document.querySelector('footer').offsetTop,
      contactUsTop = 0,
      viewPortHeight = document.body.clientHeight;
    if (isCatPage && contactUsContainer) {
      contactUsTop = contactUsContainer.offsetTop;
    }
    if (scrollTop > viewPortHeight / 2 && !contentIsLess) {
      var lastSectionTop = isCatPage ? contactUsTop : footerTop;
      if (lastSectionTop - (viewPortHeight + 10) >= scrollTop) {
        supportSidebar.classList.add(sideBarFixedClass);
        supportSidebar.classList.remove(sideBarBottomFixedClass);
      } else {
        supportSidebar.classList.add(sideBarBottomFixedClass);
      }
    }
  }
  function sidebarResizelHandler() {
    var sideBarFixedClass = 'faq-support__sidebar--fixed';
    if (document.body.clientWidth > 1024) {
      return;
    }
    if (supportSidebar) {
      supportSidebar.classList.remove(sideBarFixedClass);
    }
  }
  function searchInputFocusHandler(e) {
    if (searchInput !== document.activeElement) {
      if (e) e.preventDefault();
      searchInput.focus();
      searchPressLabel.classList.add('faq-support__search-enter-icon--hidden');
      removeMainContentHashFromUrl();
    }
  }
  window.addEventListener('scroll', function () {
    searchScrollHandler();
    sidebarScrollHandler();
  });

  window.addEventListener('resize', function () {
    searchScrollHandler();
    sidebarResizelHandler();
  });

  // Search handlers
  document.addEventListener('keypress', function (e) {
    if (e.code === 'Slash' || e.key === '/') {
      searchInputFocusHandler(e);
    }
  });
  if (searchPressLabel) {
    searchPressLabel.addEventListener('click', function () {
      searchInputFocusHandler(null);
    });
  }
  if (searchInput) {
    searchInput.addEventListener('blur', function (e) {
      if (!e.target.value) {
        searchPressLabel.classList.remove('faq-support__search-enter-icon--hidden');
      }
    });
    searchInput.addEventListener('focus', function (e) {
      searchPressLabel.classList.add('faq-support__search-enter-icon--hidden');
      if (searchFocusFlag) {
        var event = getEDSEvents()['FaqSupportSearchFocus'];
        logEdsEvent(event.name, event.options);
      }
      if (!searchFocusFlag) {
        searchFocusFlag = true;
      }
      removeMainContentHashFromUrl();
    });

    searchInput.addEventListener('keyup', function (e) {
      var value = e.target.value;
      if (value) {
        searchEnterAndClear.classList.remove('faq-support__search-submit-clear--hidden');
        searchInput.classList.remove('faq-support__search-input--no-padding');
      } else {
        searchEnterAndClear.classList.add('faq-support__search-submit-clear--hidden');
        searchInput.classList.add('faq-support__search-input--no-padding');
      }
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      searchFocusFlag = false;
      searchInput.focus();
      searchEnterAndClear.classList.add('faq-support__search-submit-clear--hidden');
      searchInput.classList.add('faq-support__search-input--no-padding');
    });
  }
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      if (!searchInput.value) {
        e.preventDefault();
        return;
      }
      var event = getEDSEvents({ searchText: searchInput.value })['FaqSupportSearchSubmit'];
      logEdsEvent(event.name, event.options);
    });
  }
  if (document.body.classList.contains('load-article-attachments')) {
    var freshdeskId = document.body.getAttribute('data-freshdesk-id');
    fetchAttachments(freshdeskId);
  }
  // Event listener for sidebar recent topic view all
  if (recentTopicCta) {
    recentTopicCta.addEventListener('click', function (e) {
      if (recentTopicsHiddenList && recentTopicsHiddenList.length) {
        from(recentTopicsHiddenList, function (ele) {
          ele.classList.remove('faq-support__recent-topics-list-item--hidden');
        });
      }
      e.target.remove();
      recentTopicsHiddenList[recentTopicsHiddenList.length - 1].focus();
    });
  }

  // Feedback widget
  function handleStepOneFunction(satisfied) {
    if (feedbackContainerStepTwo && feedbackContainerStepOne) {
      var timeFrame = Date.now();
      feedbackContainerStepTwo.classList.remove('faq-support__feedback-main--hide');
      feedbackContainerStepTwo.setAttribute('data-value', satisfied);
      feedbackContainerStepTwo.setAttribute('data-time', timeFrame);
      feedbackContainerStepOne.classList.add('faq-support__feedback-main--hide');
      var feedbackLabel = getElements('faq-support__feedback-label--' + satisfied);
      feedbackInput.focus();
      if (feedbackLabel && feedbackLabel.length) {
        from(feedbackLabel, function (ele) {
          ele.classList.remove('faq-support__feedback-label--hide');
        });
        var data = {
          title: getElements('faq-support__category__name')[0].innerText,
          isUseful: satisfied === 'like',
          reviewText: undefined,
          time: timeFrame,
        };
        var event = getEDSEvents(data)['FAQFeedbackGiven'];
        logEdsEvent(event.name, event.options);
      }
    }
  }
  function handleStepTwoFunction() {
    if (feedbackContainerStepTwo && feedbackContainerStepFinal) {
      feedbackContainerStepFinal.classList.remove('faq-support__feedback-main--hide');
      feedbackContainerStepTwo.classList.add('faq-support__feedback-main--hide');
      var dataValue = feedbackContainerStepTwo.getAttribute('data-value');
      var timeFrame = feedbackContainerStepTwo.getAttribute('data-time');
      if (feedbackContactUsLabel && dataValue === 'dislike') {
        feedbackContactUsLabel.classList.remove('faq-support__feedback-label--hide');
      }
      var data = {
        title: getElements('faq-support__category__name')[0].innerText,
        isUseful: dataValue === 'like',
        reviewText: feedbackInput.value,
        time: timeFrame,
      };
      var event = getEDSEvents(data)['FAQFeedbackGiven'];
      logEdsEvent(event.name, event.options);
    }
  }

  // Event listener Step one feedback
  if (feedbackCtaStepOne && feedbackCtaStepOne.length) {
    from(feedbackCtaStepOne, function (element) {
      element.addEventListener('click', function (e) {
        var dataValue = e.target.getAttribute('data-value');
        handleStepOneFunction(dataValue);
      });
    });
  }

  // Event listener Step two feedback
  if (feedbackCtaStepTwo && feedbackCtaStepTwo.length) {
    from(feedbackCtaStepTwo, function (element) {
      element.addEventListener('click', function (e) {
        var dataValue = e.target.getAttribute('data-value');
        handleStepTwoFunction(dataValue);
      });
    });
  }
  // EventListener Text area feedback
  if (feedbackInput) {
    feedbackInput.addEventListener('keyup', function (e) {
      if (e.target.value) {
        feedbackCtaStepTwo[1].classList.remove('faq-support__feedback-cta--disable');
        feedbackCtaStepTwo[1].removeAttribute('disabled');
      } else {
        feedbackCtaStepTwo[1].classList.add('faq-support__feedback-cta--disable');
        feedbackCtaStepTwo[1].setAttribute('disabled');
      }
    });
  }

  setTimeout(function () {
    // On support page load
    if (currentLocation.pathname === '/support') {
      var event = getEDSEvents()['onSupportLoad'];
      logEdsEvent(event.name, event.options);
    }
    // On support page load
    if (currentLocation.pathname.indexOf('/question') > -1 ) {
      var event = getEDSEvents()['onFAQLoad'];
      logEdsEvent(event.name, event.options);
    }
    //on support product pages
    var supportProductFlag = window.faqPageConfig ? window.faqPageConfig.isSupportProductPage : null;
    if (supportProductFlag) {
      var checkRefPathName = document.referrer.split('/')[3],
        getMainRefPathName = window.faqPageConfig.folder + " Page";
      if (checkRefPathName) {
        getMainRefPathName = (checkRefPathName.indexOf('support') > -1) ? 'supportPage' : getMainRefPathName;
      }
      var data = {
        pathName: getMainRefPathName,
        productName: window.faqPageConfig.product,
        linkClicked: window.location.pathname,
      };
      var event = getEDSEvents(data)['FaqSupportProductVisited'];
      logEdsEvent(event.name, event.options);
    }
  }, 100);

  // on Landing page product click
  if (supportPageProductList && supportPageProductList.length) {
    from(supportPageProductList, function (ele) {
      ele.addEventListener('click', function (e) {
        var data = {
          pathName: 'SupportPage',
          productName: ele.getAttribute('data-product'),
          linkClicked: ele.getAttribute('href'),
        };
        var event = getEDSEvents(data)['FaqSupportProductClicked'];
        logEdsEvent(event.name, event.options);
      });
    });
  }
  // on Topics click
  if (sideBarTopicList && sideBarTopicList.length) {
    from(sideBarTopicList, function (ele) {
      ele.addEventListener('click', function (e) {
        var data = {
          pathName: 'SidebarTopics',
          linkClicked: ele.getAttribute('href'),
          folderName: window.faqPageConfig.folder,
          productName: window.faqPageConfig.product,
          title: ele.getAttribute('data-title'),
        };
        var event = getEDSEvents(data)['FaqSupportFolderClicked'];
        logEdsEvent(event.name, event.options);
      });
    });
  }
  if (faqLoadMoreArticles && faqLoadMoreArticles.length) {
    from(faqLoadMoreArticles, function (ele) {
      ele.addEventListener('click', function (e) {
        var data = {
          pathName: 'ViewMore',
          linkClicked: ele.getAttribute('href'),
          faqName: window.faqPageConfig.faq,
          folderName: window.faqPageConfig.folder,
          productName: window.faqPageConfig.product,
        };
        var event = getEDSEvents(data)['FaqSupportFolderClicked'];
        logEdsEvent(event.name, event.options);
      });
    });
  }
  if (faqBreadcrumbLinks && faqBreadcrumbLinks.length) {
    from(faqBreadcrumbLinks, function (ele) {
      ele.addEventListener('click', function (e) {
        var data = {
          linkClicked: ele.getAttribute('href'),
          title: ele.getAttribute('data-title'),
          type: ele.getAttribute('data-type'),
        };
        var event = getEDSEvents(data)['FaqSupportBreadCrumbClicked'];
        logEdsEvent(event.name, event.options);
      });
    });
  }
  if (faqItems && faqItems.length) {
    from(faqItems, function (ele) {
      ele.addEventListener('click', function () {
        var data = {
          linkClicked: ele.getAttribute('href'),
          title: ele.getAttribute('data-title'),
          faqName: window.faqPageConfig.faq,
          folderName: window.faqPageConfig.folder,
          productName: window.faqPageConfig.product,
          pathName: isProductOrFolderPage ? 'Listing' : 'sidebar',
        };
        var event = getEDSEvents(data)['FaqSupportFaqClicked'];
        logEdsEvent(event.name, event.options);
      });
    });
  }
  if (faqResourceCardItems && faqResourceCardItems.length) {
    var eventMap = {
      docs: 'FaqSupportDocumentationClicked',
      status: 'FaqSupportStatusClicked',
      contact: 'FaqSupportContactClicked',
    };
    from(faqResourceCardItems, function (ele) {
      ele.addEventListener('click', function () {
        var type = ele.getAttribute('data-type');
        var eventName = eventMap[type];
        var data = {
          linkClicked: ele.getAttribute('href'),
          type: type,
          faqName: isSupportPage ? 'supportPage' : window.faqPageConfig.faq,
          folderName: isSupportPage ? 'supportPage' : window.faqPageConfig.folder,
          productName: isSupportPage ? 'supportPage' : window.faqPageConfig.product,
          pathName: isSupportPage ? 'supportPage' : 'sidebar',
        };
        var event = getEDSEvents(data)[eventName];
        logEdsEvent(event.name, event.options);
      });
    });
  }
  if (catPageBottomContactUsLink) {
    catPageBottomContactUsLink.addEventListener('click', function (e) {
      data = {
        faqName: window.faqPageConfig.faq,
        folderName: window.faqPageConfig.folder,
        productName: window.faqPageConfig.product,
      };
      var event = getEDSEvents(data)['FaqBottomContactUsClicked'];
      logEdsEvent(event.name, event.options);
    });
  }
  // on FAQ article internal links
  if (faqSecondaryTopicsLinks && faqSecondaryTopicsLinks.length) {
    from(faqSecondaryTopicsLinks, function (ele) {
      ele.addEventListener('click', function (e) {
        var data = {
          pathName: 'MainTopicsSecondaryLinks',
          linkClicked: ele.getAttribute('href'),
        };
        var event = getEDSEvents(data)['FAQSuggestedLinkClicks'];
        logEdsEvent(event.name, event.options);
      });
    });
  }

  // Dynamic Results Algolia Search Functionality
  (function faqHandleKeyboardNavigation() {
    var faqList = document.getElementById('local-search-autocomplete'),
      faqSearchInput = document.querySelectorAll('.faq-support__search-input')[0],
      faqItems = faqList.getElementsByTagName('a'),
      faqSelectedItem = null;
  
    faqSearchInput.addEventListener('keydown', function(event) {
      if (faqItems.length > 0 && event.key === 'ArrowDown') {
        faqItems[0].focus();
        faqSelectedItem = faqItems[0];
      }
      if (event.key === 'Escape' || event.keyCode === 27) {
        faqSearchInput.value = '';
        searchFocusFlag = false;
        faqSearchInput.focus();
        faqList.innerHTML = '';
        searchEnterAndClear.classList.add('faq-support__search-submit-clear--hidden');
        faqSearchInput.classList.add('faq-support__search-input--no-padding');
      }
    });
  
    faqList.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowDown') {
        // Move focus to the next list item
        faqSelectedItem = faqGetNextItem(faqSelectedItem);
        faqSelectedItem.focus();
        event.preventDefault();
      } else if (event.key === 'ArrowUp') {
        // Move focus to the previous list item
        faqSelectedItem = faqGetPreviousItem(faqSelectedItem);
        faqSelectedItem.focus();
        event.preventDefault();
      } else if (event.key === 'Escape' || event.keyCode === 27) {
        faqSearchInput.value = '';
        searchFocusFlag = false;
        faqSearchInput.focus();
        faqList.innerHTML = '';
        searchEnterAndClear.classList.add('faq-support__search-submit-clear--hidden');
        faqSearchInput.classList.add('faq-support__search-input--no-padding');
      }
    });
  
    // Helper function to get the next list item
    function faqGetNextItem(item) {
      if (!item) {
        return faqItems[0];
      }
      if (item.nextElementSibling) {
        return item.nextElementSibling;
      }
      return faqItems[0];
    }
  
    // Helper function to get the previous list item
    function faqGetPreviousItem(item) {
      if (!item) {
        return faqItems[0];
      }
      if (item.previousElementSibling) {
        return item.previousElementSibling;
      }
      return faqItems[faqItems.length - 1];
    }
  })();

  // recursive function to determine the parent anchor element of the suggestion list
  function findTargetAnchor(target) {
    if (target) {
      if (target.nodeName.toLowerCase() === 'a') {
        return target;
      }
      return findTargetAnchor(target.parentNode);
    }
  }

  // handling analytics for dynamic results click
  (function() {
    var autocomplete = document.getElementById('local-search-autocomplete');
    autocomplete.addEventListener('click', function(event) {
      var targetAnchor = findTargetAnchor(event.target);
      if (targetAnchor) {
        var data = {
          action: targetAnchor.classList.contains('global-search__see-all-result')
            ? 'see_all_result'
            : 'clicked_on_drop_down_result',
          clicked_on_url: targetAnchor.getAttribute('href'),
          position: targetAnchor.getAttribute('data-index') + 1,
          search_text: targetAnchor.getAttribute('data-query'),
          content_type: targetAnchor.classList.contains('global-search__see-all-result')
            ? ''
            : targetAnchor.getAttribute('data-category')
        };
        var event = getEDSEvents(data)['FaqSupportDynamicSearchClicked'];
        logEdsEvent(event.name, event.options);
      }
    });
  })();
});
